import { connect } from 'react-redux';
//
import { IStoreState } from 'store';
import ForecastToggle from 'components/forecast-toggle/forecast-toggle';
import { EForecastEvaluationType } from 'store/deal-evaluation/types';
import { setForecastType } from 'store/deal-evaluation/actions';

export interface IForecastToggleProps {
  selectedForecastType: EForecastEvaluationType;
  setForecastType: (forecastType: EForecastEvaluationType) => void;
}

export interface IForecastToggleOwnProps {
  showTitle: boolean;
}

export type TForecastToggleProps = IForecastToggleProps & IForecastToggleOwnProps;

const mapStateToProps = ({ dealEvaluation }: IStoreState) => ({
  selectedForecastType: dealEvaluation.selectedForecastType,
});

const mapDispatchToProps = {
  setForecastType,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForecastToggle);
